import classNames from 'styles/utils/classNames';
import CourtOption from './CourtOption';
import { BookableCourt } from './types';

interface Props {
  courts: BookableCourt[];
  selectedCourtId: string | null;
  onCourtSelect: (courtId: string) => void;
  /** Hidden when null — the court modal already has its own header. */
  title?: string | null;
  className?: string;
}

export default function CourtList({
  courts,
  selectedCourtId,
  onCourtSelect,
  title = 'Available courts',
  className,
}: Props) {
  return (
    <div className={classNames('flex flex-col gap-ds-md', className)}>
      {title && (
        <p className="typography-product-subheading-mobile text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          {title}
        </p>
      )}
      {courts.length === 0 ? (
        <p className="typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          No courts are free for those times. Try another slot or day.
        </p>
      ) : (
        courts.map((court) => (
          <CourtOption
            key={court.id}
            court={court}
            isSelected={court.id === selectedCourtId}
            onSelect={onCourtSelect}
          />
        ))
      )}
    </div>
  );
}
